import React, { useState, useRef, useEffect, useContext } from "react";
import ScreenBGItemScreen from "./ScreenBGItemScreen";
import VideoPlayer from "./videoPlayer/videoPlayer";
import { fetchContent, fetchContent1 } from "../services/api";
import LoaderScreen from "./LoaderScreen";
import SeriesDetails from "./SeriesDetails.json";
import ModalScreen from "./ModalScreen";
import ToastScreen from "./ToastScreen";
import loginimg from "../assets/loginimg.png";
import PDFViewer from "./PdfViewer";
import premium from "../assets/Premium.png";
import rent from "../assets/Rent.png";
import AudioPlayer from "./AudioPlayer";
import qrImage from "../assets/qrImage.png";
import ErrorScreen from "./ErrorScreen";
// import errorIcon from "../assets/NoDataFound.png";
import errorIcon from "../assets/NoSearchResultFound1.png";
import {
  createDrmLicenseV2,
  getContentDetails,
  getContentPlaybackInfo,
  getVideoUrlV2,
  setEventReminder,
  getLiveChannelDetails
} from "../services/services";
import logoutIcon from "../assets/Logout-Icon.png";
import AuthFailModal from "./AuthFailModal";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import { event } from "jquery";

let resolution = window.RESOLUTION;
let dataWrapper = [];
let itmDetails = [];

const DetailsScreen = ({
  handleBack,
  firstTag,
  data,
  isLogedIn,
  navigate,
  appinappData,
  shouldAuthError,
  isLiveEvent,
  isLiveScreen = false,
  detailToDetail,
  selectedTag,
  premiumQr
  // isError = false,
}) => {

  // useEffect(() => {
  //   console.log("data fromdetail", data)
  // })
  const [screen, setScreen] = useState("DetailsScreen");
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [shouldFocusToScreenBG, setShouldFocusToScreenBG] = useState(true);
  const { isAppInAppData, setIsAppInAppData } = useContext(AppContext);
  const [plansPrice, setPlansPrice] = useState(0);
  const [NoDataFound, setNoDataFound] = useState(false)
  const [state, setState] = useState({
    shouldFocusToScreenBG: true,
    isLogedInUser: isLogedIn,
    loading: true,
    // itemDetails: [data],
    itemDetails: [],
    shouldShowError: false,
    shouldShowAuthModal: false,
    shouldRental: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    iconWdth: "100px",
    iconHeight: "100px",
    button: ["Ok", "Cancel"],
    okaybtn: ["Okay"],
    shouldShowToast: false,
    toastMsg: "",
    toastBgColor: "#FF00FF",
    DRMToken: null,
    typ: "hls",
    DRMvdoSRC: null,
    DrmInformatin: null,
    GetVideoUrlData: null,
    GetVideoUrlData_audio: null,
    currentItemSeason: null,
    VideoDataDrm: null,
    shouldRemindPopup: false,
    isError: false,
  });

  // useEffect(()=>{
  //   console.log("plansPrice", plansPrice)
  // },[plansPrice])

  const {
    isLogedInUser,
    loading,
    itemDetails,
    hasNextContent,
    season,
    episode,
    shouldShowError,
    shouldShowAuthModal,
    errTitle,
    errDescription,
    errIcon,
    iconWdth,
    iconHeight,
    button,
    shouldShowToast,
    toastMsg,
    toastBgColor,
    DRMToken,
    typ,
    DRMvdoSRC,
    DrmInformatin,
    GetVideoUrlData,
    GetVideoUrlData_audio,
    okaybtn,
    currentItemSeason,
    VideoDataDrm,
    shouldRemindPopup,
    isError,
    shouldRental,
  } = state;
  dataWrapper = [];
  dataWrapper.push(data);
  let ScreenComponent;
  let videodataResponse2;

  // useEffect(() => {
  //   // console.log("state", state)
  //   let price = state?.itemDetails[0]?.pricing?.s_price + state?.itemDetails[0]?.pricing?.gst_amount
  //   setPlansPrice(price)
  // }, [state])
  const userD = localStorage.getItem("user_details");
  const userDetais = JSON.parse(userD);
  const Is_subscribe =
    userD == null || undefined ? 0 : userDetais?.user_profiles[0]?.is_subscribe;

  console.log("data....123", isLogedIn, isLogedInUser);
  // const premiumQr = localStorage.getItem("masterData")
  console.log(premiumQr, "premiumQr")
  const navigateToScreen = (screenname) => {
    console.log("screenname...", screenname);
    setScreen(screenname);
  };
  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        localStorage.removeItem("user_details");
        localStorage.removeItem("userId");
        localStorage.removeItem("profileId");
        localStorage.clear();
        window.appReload();
        // navigate("LoginScreen");
        // console.log("action...", action);
        // localStorage.removeItem('user_details');
        // localStorage.removeItem('userId');
        // localStorage.removeItem('profileId');
        // localStorage.clear();
        // navigate("LoginScreen");
        navigateToScreen("LoginScreen");
        break;
      case "Ok":
        setState((prevState) => ({
          ...prevState,
          shouldShowError: false,
          shouldFocusToScreenBG: true,
        }));
        ScreenBGItemScreen.setFocus(true);
        break;

      case "Okay, Got it":
        console.log("okay")
        setState((prevState) => ({
          ...prevState,
          shouldRental: false,
          shouldFocusToScreenBG: true,   
        }));
        ScreenBGItemScreen.setFocus(true);
        break;
      default:
        break;
    }
  };
  const modalCANCELButtonHandler = () => {
    setState((prevState) => ({
      ...prevState,
      shouldShowError: false,
      shouldFocusToScreenBG: true,
    }));
    ScreenBGItemScreen.setFocus(true);
    ScreenBGItemScreen.ReseTfocus(1);
    // ScreenBGItemScreen.ReseTfocus(1);
    // ScreenBGItemScreen.ReseTfocus(true)
  };

  const remindPopup = () => {
    console.log("remindPopup...");
    setState((prevState) => ({
      ...prevState,
      shouldRemindPopup: false,
      shouldShowError: false,
      shouldRental: false,
      shouldFocusToScreenBG: true,
    }));
    ScreenBGItemScreen.setFocus(true);
    ScreenBGItemScreen.ReseTfocus(1);
  };

  // const plans_price = itemDetails[0]?.pricing?.s_price + itemDetails[0]?.pricing?.gst_amount
  // const sPrice = Number(itemDetails[0]?.pricing?.s_price || 0);
  // const gstAmount = Number(itemDetails[0]?.pricing?.gst_amount || 0);
  // const plans_price = sPrice + gstAmount;
  // console.log("plans_price...", plans_price);

  ////console.log("itemDetails...", itemDetails[0]?.pricing?.mrp, itemDetails[0], appinappData);

  const handleErr = (errTp) => {
    let errttile = "";
    let errDescription = "";
    let errIcon = "";
    let btn = [];
    let okbtn = [];
    if (errTp === "NOT-AUTHENTICATED") {
      errttile = "Login to Continue";
      errDescription = "LoginContinue";
      errIcon = loginimg;
      // errttile = "Authentication Failed!";
      // errDescription = "Login Required.";
      // errIcon = "../assets/errorIcon.png";
      btn = ["Login", "Cancel"];
    } else if (errTp === "PLAYBACKURL-ERROR") {
      errttile = "Playback URL error!";
      errDescription = "Playback url can't be undefined or blank.";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "WATCHLISTADD-ERROR") {
      errttile = "Error!";
      errDescription = "WatchlistError";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "WATCHLISTADD-SUCCCESS") {
      errttile = "Success";
      errDescription = "WatchlistSuccess";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "RENTAL-MESSAGE") {

      console.log("RENTAL-MESSAGE", itemDetails[0]?.pricing?.mrp, itemDetails);
      // const plans_price = itemDetails[0]?.pricing?.s_price + itemDetails[0]?.pricing?.gst_amount
      errttile = { x: "RentAvailable", y: plansPrice };
      // console.log("RENTAL-MESSAGE", itemDetails[0]?.pricing?.mrp, itemDetails);
      // errttile = { x: "RentAvailable", y: itemDetails[0]?.pricing?.mrp };
      errDescription = "RentMsg";
      errIcon = `${rent}`;
      btn = ["Ok", "Cancel"];
    } else if (errTp === "SUBSCRIBE-MESSAGE") {
      errttile = "Subscribewatch";
      errDescription = "SubscribeMsg";
      errIcon = "";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "GAME-MESSAGE") {
      errttile = "GamePlay";
      errDescription = "PlayMsg";
      errIcon = "";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "AUTH-ERROR") {

      // errttile = "Session-Expired";
      errDescription = "session-desc";
      errIcon = `${logoutIcon}`;
      btn = ["Login"];
    } else if (errTp === "GET-REMINDER") {
      console.log(
        "shouldshowError.....",
        shouldShowError,
        shouldRemindPopup,
        errTp
      );
      errttile = "Login to Continue";
      errDescription = "LoginContinue";
      errIcon = loginimg;
      // errttile = "Authentication Failed!";
      // errDescription = "Login Required.";
      // errIcon = "../assets/errorIcon.png";
      btn = ["Login", "Cancel"];
    }
    console.log("Hello", errTp)
    if (errTp === "AUTH-ERROR") {
      console.log("Session Expired", errttile, errDescription, errIcon);

      setState((prevState) => ({
        ...prevState,
        shouldShowError: false,
        shouldRental: false,
        shouldShowAuthModal: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: errIcon,
        button: btn,
        okaybtn: "Login to Continue",
      }));
    } else if (errTp === "RENTAL-MESSAGE") {
      // let price = state?.itemDetails[0]?.pricing?.s_price + state?.itemDetails[0]?.pricing?.gst_amount 
      errttile = { x: "RentAvailable", y: plansPrice };
      // console.log("RENTAL-MESSAGE", itemDetails[0]?.pricing?.mrp, itemDetails);
      // errttile = { x: "RentAvailable", y: itemDetails[0]?.pricing?.mrp };
      errDescription = "RentMsg";
      errIcon = `${rent}`;
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));




    } else if (errTp === "GAME-MESSAGE") {

      console.log(premiumQr, "premiumQr1")
      // console.log("RENTAL-MESSAGE", itemDetails[0]?.pricing?.mrp, itemDetails);
      // errttile = { x: "RentAvailable", y: itemDetails[0]?.pricing?.mrp };
      errttile = "GamePlay";
      errDescription = "PlayMsg";
      errIcon = "";
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));


    }
    else if (errTp === "SUBSCRIBE-MESSAGE") {
      errttile = "Subscribewatch";
      errDescription = "SubscribeMsg";
      errIcon = "";
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));


    } else {
      console.log(
        "shouldshowError.....",
        shouldShowError,
        shouldRemindPopup,
        shouldShowAuthModal,
        errTp
      );
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: errTp === "GET-REMINDER" ? true : false,
        shouldShowError: errTp !== "GET-REMINDER" ? true : false,
        shouldShowAuthModal: false,
        shouldRental: false,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: errIcon,
        button: btn,
        okaybtn: okbtn,
      }));

      // setState((prevState) => ({
      //   ...prevState,
      //   shouldShowError: true,
      //   shouldShowAuthModal: false,
      //   errTitle: errttile,
      //   errDescription: errDescription,
      //   errIcon: errIcon,
      //   button: btn,
      //   okaybtn: okbtn,
      // }));
    }
  };

  //  const callBack = (screenName) => {
  //   handleBack(screenName);
  // };

  const callBack = async (screenName) => {
    console.log("first1111", screenName, sourceContext);

    // Checking is this appinapp data
    const isAppInApp = isAppInAppData;

    if (isAppInApp) {
      setSourceContext(isAppInApp);
      setIsAppInAppData("");
      handleBack(screenName);
    } else if (selectedTag) {
      setSourceContext(`Home/Tag(${selectedTag?.id}/${selectedTag?.title})`);
      handleBack(screenName);
    } else {
      handleBack(screenName);
    }
  };

  const updateNextEpisodeObject = (itemDetailsData, seasonId, episodeId) => {
    let seasonObj = null;
    let episodeObj = null;
    let hasNextContent = false;
    let currentItemSeason = episodeId;

    for (
      let seasonIndex = 0;
      seasonIndex < itemDetailsData.season.length;
      seasonIndex++
    ) {
      const season = itemDetailsData.season[seasonIndex];
      if (season.id === seasonId) {
        for (
          let videoIndex = 0;
          videoIndex < season.videos.length;
          videoIndex++
        ) {
          if (season.videos[videoIndex].id === episodeId) {
            if (videoIndex + 1 < season.videos.length) {
              seasonObj = season;
              episodeObj = season.videos[videoIndex + 1];
              hasNextContent = true;
            } else if (seasonIndex + 1 < itemDetailsData.season.length) {
              seasonObj = itemDetailsData.season[seasonIndex + 1];
              episodeObj = seasonObj.videos[0];
              hasNextContent = true;
            } else {
              console.info(`No next episode/seasons`);
            }
            break;
          }
        }
        if (episodeObj) break;
        else hasNextContent = false;
      }
    }

    console.log("SAVING updateNextEpisodeObject", episodeObj);
    setState((prevState) => ({
      ...prevState,
      hasNextContent,
      season: seasonObj,
      episode: episodeObj,
      currentItemSeason: currentItemSeason,
    }));
  };

  const onSelect = (item) => {
    let isEpisode = false;
    if (item.season_id) {
      isEpisode = true;
    }

    if (item?.type === 1 || item?.media_type === 1) {
      navigateToScreen("AudioPlayer", item);
    }

    if (isEpisode) {
      if (item?.type === 1 || item?.media_type === 1) {
        navigateToScreen("AudioPlayer", item);
      } else {
      getDRMLicense(item, itemDetails[0]);
      // navigateToScreen("DetailsScreen", itemDetails[0]);
      navigateToScreen("VideoScreen");
      updateNextEpisodeObject(itemDetails[0], item.season_id, item.id);
      }
    } else {
      if (typeof detailToDetail === "function") {
        console.log("detailToDetail Item ::", item);
        //Valid only for Detail to Detail if launched from Home Page
        detailToDetail(item);
      } else {
        // console.log(item, itemDetails, "SimilarTothis1");
        //if not launch from Home Page then Fallbak
        // console.log("navigateToScreen Item ::", item);
        getDRMLicense(item, item);
        navigateToScreen("DetailsScreen", item);

        //Motamo Event 

        const videoType = itemDetails?.[0]?.category_title;
        let mediaType = "";

        switch (videoType) {
          case "TV Channels":
          case "Live":
            mediaType = "LiveChannel";
            break;

          case "Movies":
          case "Shows":
            mediaType = "Video";
            break;

          case "Radio Channels":
            mediaType = "Live Radio";
            break;

          case "Audio":
            mediaType = "Audio";
            break;

          default:
            return;
        }
        sendTestMatomoEvent({
          eventCategory: "SimilarToThis",
          eventAction: "ContentSelected",
          eventName: `(${mediaType})/${item?.id}/${item?.title}`,
          url: "details",
        });
      }
    }
  };

  // const onSelect = (item) => {
  //   let isEpisode = false;
  //   if (item.season_id) {
  //     isEpisode = true;
  //   }

  //   console.log("onSelect Item ::", item, isEpisode, detailToDetail);

  // if (item?.type === 1 || item?.media_type === 1) {
  //   navigateToScreen("AudioPlayer", item);
  // }

  //   if (item?.still_live !== 1) {

  //     if (isEpisode) {
  //       getDRMLicense(item, itemDetails[0]);
  //       if (item?.type === 1 || item?.media_type === 1) {
  //         navigateToScreen("AudioPlayer", item);
  //       } else {
  //         console.log("Live Channel selected....");
  //         // navigateToScreen("DetailsScreen", itemDetails[0]);
  //         navigateToScreen("VideoScreen");
  //         updateNextEpisodeObject(itemDetails[0], item.season_id, item.id);
  //       }
  //     } else {
  //       if (typeof detailToDetail === "function") {
  //         console.log("detailToDetail Item ::", item);
  //         //Valid only for Detail to Detail if launched from Home Page
  //         detailToDetail(item);
  //       } else {
  //         console.log(item, itemDetails, "SimilarTothis1");
  //         //if not launch from Home Page then Fallbak
  //         // console.log("navigateToScreen Item ::", item);
  //         getDRMLicense(item, item);
  //         navigateToScreen("DetailsScreen", item);

  //         //Motamo Event 

  //         const videoType = itemDetails?.[0]?.category_title;
  //         let mediaType = "";

  //         switch (videoType) {
  //           case "TV Channels":
  //           case "Live":
  //             mediaType = "LiveChannel";
  //             break;

  //           case "Movies":
  //           case "Shows":
  //             mediaType = "Video";
  //             break;

  //           case "Radio Channels":
  //             mediaType = "Live Radio";
  //             break;

  //           case "Audio":
  //             mediaType = "Audio";
  //             break;

  //           default:
  //             return;
  //         }
  //         sendTestMatomoEvent({
  //           eventCategory: "SimilarToThis",
  //           eventAction: "ContentSelected",
  //           eventName: `(${mediaType})/${item?.id}/${item?.title}`,
  //           url: "details",
  //         });
  //       }
  //     }
  //   }
  // else {
  //   console.log("Live Channel selected....");
  //   navigateToScreen("VideoScreen", item);
  // }
  // };

  const handleVideoBack = () => {
    navigateToScreen("DetailsScreen");
    setScreen("DetailsScreen");
    setShouldFocusToScreenBG(true);

    // if (itemDetails?.[0]?.type === 4) {
    //   sendTestMatomoEvent({
    //     eventCategory: "Image",
    //     eventAction: "Close",
    //     eventName: `${itemDetails?.[0]?.id}/${itemDetails?.[0]?.title}`,
    //   });
    // }
  };

  let hasFetchedData = false;
  let isGridCalled = true;

  const getDRMFileDetails = async (firstEpisode, data, drmData) => {
    console.log("getDRMFileDetails.....", firstEpisode, data, drmData);
    try {
      let mpdInfo = null;
      const headers = {
        Version: localStorage.getItem("version"),
        devicetype: "11",
        Deviceid: localStorage.getItem("macAddress"),
        Devicetoken: localStorage.getItem("uuid"),
        Devicemodel: localStorage.getItem("modelCode"),
        Profileid: localStorage.getItem("profileId"),
        // Profileid: 1,
        "Content-Type": "application/json",
      };
      const requestOptions = {
        method: "POST",
        redirect: "follow",
      };
      const CDNDomain = drmData.file_url.split("/v1");
      [mpdInfo] = await Promise.all([fetch(drmData.file_url, requestOptions)]);
      // Check if the responses are okay
      if (!mpdInfo.ok) {
        throw new Error("mpd file POST failed");
      }
      const mpdData = await mpdInfo.json();
      itmDetails = [data];
      console.log("itmDetails 1", itmDetails)
      setState((prevState) => ({
        ...prevState,
        loading: false,
        //itemDetails:[SeriesDetails.data]
        itemDetails: [data],
        DRMToken: drmData.token,
        typ: "mpd",
        DRMvdoSRC: CDNDomain[0] + mpdData.manifestUrl,
      }));
    } catch (error) {
      console.log("DRMFILES ERROR 1", error)
      setState((prevState) => ({
        ...prevState,
        loading: false,
        itemDetails: [data],
        shouldFocusToScreenBG: true,
        shouldShowToast: false,
        toastMsg: "Playback URL error! Please try again later.",
        toastBgColor: "red",
      }));
    }
  };

  const getDRMLicense = async (firstEpisode, data) => {
    console.log("firstEpisode.....", firstEpisode, data);
    const profile_id = localStorage.getItem("profileId");
    console.log("2222222222222.......", firstEpisode, data);

    if (!data) {
      return;
    }

    if (data.owned_by !== 0) {
      return;
    }

    if (
      data !== undefined &&
      data.owned_by !== undefined &&
      data.owned_by == 0
    ) {
      try {
        let drmInfo = null;
        const headers = {
          Version: localStorage.getItem("version"),

          Deviceid: localStorage.getItem("macAddress"),
          Devicetoken: localStorage.getItem("uuid"),
          Devicemodel: localStorage.getItem("modelCode"),
          Profileid: 1,
          "Content-Type": "application/json",
        };

        const postBody = {
          vdc_id: firstEpisode.vdc_id,
          media_id: firstEpisode.video_id
            ? firstEpisode.video_id
            : firstEpisode.id,
        };
        // [drmInfo] = await Promise.all([
        //   fetchContent(
        //     `/V1/createDrmLicenseV2?display=${Is_subscribe == 0 ? "false" : "true"}`,
        //     "POST",
        //     headers,
        //     JSON.stringify(postBody)
        //   ),
        // ]);

        const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";

        drmInfo = await createDrmLicenseV2(isSubscribe, postBody);

        getDRMFileDetails(firstEpisode, data, drmInfo.data);

        setState((prevState) => ({
          ...prevState,
          DrmInformatin: drmInfo,
          GetVideoUrlData: drmInfo,
        }));

        console.log("1111111111.....", firstEpisode, data, drmInfo.data);
      } catch (error) {
        console.log("4444444444..........", error);
        setState((prevState) => ({
          ...prevState,
          loading: false,
          itemDetails: [data],
          shouldShowToast: false,
          toastMsg: "Playback error! Please try again later.",
          toastBgColor: "red",
        }));
      }
    }
  };

  console.log("details page...", data);

  const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");

  const gender =
    userDetails?.gender === 1
      ? "Male"
      : userDetails?.gender === 2
        ? "Female"
        : "Not Available";

  const age = userDetails?.dob
    ? calculateAge(userDetails.dob)
    : "Not Available";



  const ages = age == "Not Available" ? 100 : age;


  const profile = JSON.parse(localStorage.getItem("myProfile"));

  const profileType =
    profile?.isKids === 0 || profile?.is_kid === 0
      ? "Adult"
      : profile?.isKids === 1 || profile?.is_kid === 1
        ? "Child"
        : "";


  function calculateAge(dobString) {
    if (!dobString) return null;
    const today = new Date();
    const dob = new Date(dobString);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // adjust if birthday hasn't happened yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }
const loadData = async () => {

    if (hasFetchedData) return;

    hasFetchedData = true;

    if (!isGridCalled) return;
 
    const userId = localStorage.getItem("profileId");

    const getCountry = localStorage.getItem("country");
 
    console.log("age...", age);
 
    let headers = {

      iskid: "0",

      Langid: "1",

      "Content-Type": "application/json",

      country: getCountry,

      age: ages,

      platform: "0",

    };
 
    let partnerheaders = {

      publisher_id: `${data?.owned_by}`,

      event: "false",

      tag: "0",

    };
 
    const platform = 0;
 
    try {

      const [fetchedItemDetails, fetchVideoUrl] = await Promise.all([

        //   // Fetch content details

        //   fetchContent(

        //     `/V1/getContentDetails/${data.show_id ? data.show_id : data.id}`,

        //     "GET",

        //     headers

        //   ),
 
        await getContentDetails(data.show_id ? data.show_id : data.id, platform),
 
        // Fetch video URL

        (async () => {

          // const videoID =

          //   data?.video_id ||

          //   data?.show_id ||

          //   (

          //     await fetchContent(

          //       `/V1/getContentDetails/${

          //         data.video_id ? data.show_id : data.id

          //       }`,

          //       "GET",

          //       headers

          //     )

          //   )?.data?.season?.[0]?.videos?.[0]?.id;
 
          const videoID =

            data?.video_id ||

            data?.show_id ||

            (await getContentDetails(data.video_id ? data.show_id : data.id, platform))

              ?.data?.season?.[0]?.videos?.[0]?.id;
 
          if (!videoID) {

            // console.error("Unable to determine video ID");

            return null;

          }
 
          console.log("videoid", videoID, data, data.owned_by);
 
          let videoUrlResponse = null;

          const body = {

            contentId: data?.contentId,

          };
 
          // const jsonBody = JSON.stringify(body);

          const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";
 
          if (data.owned_by == undefined || data.owned_by == 0) {

            // videoUrlResponse = await fetchContent(

            //   `/V1/getVideoUrlV2/${videoID}/userId/${userId}?display=${Is_subscribe == 0 ? "false" : "true"}`,

            //   "GET",

            //   headers

            // );

            videoUrlResponse = await getVideoUrlV2(

              videoID,

              userId,

              isSubscribe

            );

          } else if (data.owned_by > 0) {

            // videoUrlResponse = await fetchContent1(

            //   `/V1/getContentPlaybackInfo?publisher_id=${data?.owned_by}`,

            //   "POST",

            //   JSON.stringify(partnerheaders),

            //   body

            // );

            videoUrlResponse = await getContentPlaybackInfo(

              data?.owned_by,

              body,

              partnerheaders

            );

            // setState((prevState) => ({

            //   ...prevState,

            //   VideoDataDrm: videoUrlResponse.data,

            // }));

            // videoUrlResponse = getContentPlaybackInfo(data?.owned_by);

          }

          if (videoUrlResponse.data) {

            setState((prevState) => ({

              ...prevState,

              VideoDataDrm: videoUrlResponse.data,

            }));

            videodataResponse2 = videoUrlResponse;

          }

          console.log("videoUrlResponse:", videoUrlResponse, videoID);

          return videoUrlResponse;

        })(),

      ]);
 
      // console.log("Details Screen....", fetchedItemDetails, fetchVideoUrl);

      //  const planIds = fetchedItemDetails?.data?.plans

      //   .split(',')

      //   .map(id => Number(id)); // Convert to array of numbers
 
      // console.log("planIds");
 
      if (fetchedItemDetails.statusCode == 404) {

        // isError = true;

        setState((prevState) => ({

          ...prevState,

          isError: true,

          loading: false,

        }));

      }
 
      // if (data.owned_by == 0){

      if (fetchedItemDetails.data !== undefined) {

        if (

          fetchedItemDetails.data.season !== undefined &&

          fetchedItemDetails.data.season.length > 0 &&

          fetchedItemDetails.data.season[0].videos !== undefined &&

          fetchedItemDetails.data.season[0].videos.length > 0 &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==

          undefined &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 1

        ) {

          if (data.owned_by == undefined || data.owned_by == 0)

            getDRMLicense(

              fetchedItemDetails.data.season[0].videos[0],

              fetchedItemDetails.data

            );

          //STATE FOR DRM_CONTENT

          console.log(

            "STATE FOR DRM_CONTENT SET.............",

            GetVideoUrlData

          );

          setState((prevState) => ({

            ...prevState,

            loading: false,

            itemDetails: [fetchedItemDetails.data],

            GetVideoUrlData: [fetchVideoUrl?.data],

          }));
 
          sendMatomo(fetchedItemDetails.data);

          console.log("GetVideoUrlData...", GetVideoUrlData);

        } else if (

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==

          undefined &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 0

        ) {

          //STATE FOR NON_DRM_CONTENT

          console.log(

            "STATE FOR NON_DRM_CONTENT SET...............",

            GetVideoUrlData

          );

          setState((prevState) => ({

            ...prevState,

            loading: false,

            itemDetails: [fetchedItemDetails.data],

            GetVideoUrlData: [fetchVideoUrl?.data],

          }));

        }

      } else {

        setState((prevState) => ({

          ...prevState,

          isError: true,

          loading: false,

          shouldShowToast: false,

          toastMsg: "Playback error! Please try again later.",

          toastBgColor: "red",

        }));

      }
 
      if (firstTag === "Radio") {

        // LiveRadio-Selected-contentid/contentName event

        await sendTestMatomoEvent({

          eventCategory: "LiveRadio",

          eventAction: "Selected",

          eventName: `${data?.id}/${data?.title}`,

          url: "details",

        });

      } else if (firstTag === "TV") {

        // liveChannel event

        await sendTestMatomoEvent({

          eventCategory: "LiveChannel",

          eventAction: "Selected",

          eventName: `${data?.id}/${data?.title}`,

          url: "details",

        });

      }

      // }

      isGridCalled = false;

      // setPlansPrice(fetchedItemDetails?.data?.pricing?.s_price + fetchedItemDetails?.data?.pricing?.gst_amount);

    } catch (error) {

      // //console.error("Error fetching data:", error);

      setState((prevState) => ({

        ...prevState,

        loading: false,

        shouldShowToast: false,

        toastMsg: "Playback error! Please try again later.",

        toastBgColor: "red",

      }));

      isGridCalled = false;

    }

  };

 

  // const loadData = async () => {
  //   if (hasFetchedData) return;
  //   hasFetchedData = true;
  //   if (!isGridCalled) return;

  //   const userId = localStorage.getItem("profileId");
  //   const getCountry = localStorage.getItem("country");

  //   console.log("age...", age);

  //   let headers = {
  //     iskid: "0",
  //     Langid: "1",
  //     "Content-Type": "application/json",
  //     country: getCountry,
  //     age: ages,
  //     platform: "0",
  //   };

  //   let partnerheaders = {
  //     publisher_id: `${data?.owned_by}`,
  //     event: "false",
  //     tag: "0",
  //   };

  //   const platform = 0;

  //   try {
  //     const [fetchedItemDetails, fetchVideoUrl] = await Promise.all([
  //       //   // Fetch content details
  //       //   fetchContent(
  //       //     `/V1/getContentDetails/${data.show_id ? data.show_id : data.id}`,
  //       //     "GET",
  //       //     headers
  //       //   ),

  //       await getContentDetails(data.show_id ? data.show_id : data.id, platform),

  //       // Fetch video URL
  //       (async () => {
  //         // const videoID =
  //         //   data?.video_id ||
  //         //   data?.show_id ||
  //         //   (
  //         //     await fetchContent(
  //         //       `/V1/getContentDetails/${
  //         //         data.video_id ? data.show_id : data.id
  //         //       }`,
  //         //       "GET",
  //         //       headers
  //         //     )
  //         //   )?.data?.season?.[0]?.videos?.[0]?.id;

  //         const videoID =
  //           data?.video_id ||
  //           data?.show_id ||
  //           (await getContentDetails(data.video_id ? data.show_id : data.id, platform))
  //             ?.data?.season?.[0]?.videos?.[0]?.id;

  //         if (!videoID) {
  //           // console.error("Unable to determine video ID");
  //           return null;
  //         }

  //         console.log("videoid", videoID, data, data.owned_by);

  //         let videoUrlResponse = null;
  //         const body = {
  //           contentId: data?.contentId,
  //         };

  //         // const jsonBody = JSON.stringify(body);
  //         const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";

  //         if (data.owned_by == undefined || data.owned_by == 0) {
  //           // videoUrlResponse = await fetchContent(
  //           //   `/V1/getVideoUrlV2/${videoID}/userId/${userId}?display=${Is_subscribe == 0 ? "false" : "true"}`,
  //           //   "GET",
  //           //   headers
  //           // );
  //           videoUrlResponse = await getVideoUrlV2(
  //             videoID,
  //             userId,
  //             isSubscribe
  //           );
  //         } else if (data.owned_by > 0) {
  //           // videoUrlResponse = await fetchContent1(
  //           //   `/V1/getContentPlaybackInfo?publisher_id=${data?.owned_by}`,
  //           //   "POST",
  //           //   JSON.stringify(partnerheaders),
  //           //   body
  //           // );
  //           videoUrlResponse = await getContentPlaybackInfo(
  //             data?.owned_by,
  //             body,
  //             partnerheaders
  //           );
  //           setState((prevState) => ({
  //             ...prevState,
  //             VideoDataDrm: videoUrlResponse.data,
  //           }));
  //           // videoUrlResponse = getContentPlaybackInfo(data?.owned_by);
  //         }
  //         if (videoUrlResponse.data) {
  //           setState((prevState) => ({
  //             ...prevState,
  //             VideoDataDrm: videoUrlResponse.data,
  //           }));
  //           videodataResponse2 = videoUrlResponse;
  //         }
  //         console.log("videoUrlResponse:", videoUrlResponse, videoID);
  //         return videoUrlResponse;
  //       })(),
  //     ]);

  //     // console.log("Details Screen....", fetchedItemDetails, fetchVideoUrl);
  //     //  const planIds = fetchedItemDetails?.data?.plans
  //     //   .split(',')
  //     //   .map(id => Number(id)); // Convert to array of numbers

  //     // console.log("planIds");

  //     if (fetchedItemDetails.statusCode == 404) {
  //       // isError = true;
  //       setState((prevState) => ({
  //         ...prevState,
  //         isError: true,
  //         loading: false,
  //       }));
  //     }

  //     // if (data.owned_by == 0){
  //     if (fetchedItemDetails.data !== undefined) {
  //       if (
  //         fetchedItemDetails.data.season !== undefined &&
  //         fetchedItemDetails.data.season.length > 0 &&
  //         fetchedItemDetails.data.season[0].videos !== undefined &&
  //         fetchedItemDetails.data.season[0].videos.length > 0 &&
  //         fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==
  //         undefined &&
  //         fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 1
  //       ) {
  //         if (data.owned_by == undefined || data.owned_by == 0)
  //           getDRMLicense(
  //             fetchedItemDetails.data.season[0].videos[0],
  //             fetchedItemDetails.data
  //           );
  //         //STATE FOR DRM_CONTENT
  //         console.log(
  //           "STATE FOR DRM_CONTENT SET.............",
  //           GetVideoUrlData
  //         );
  //         setState((prevState) => ({
  //           ...prevState,
  //           loading: false,
  //           itemDetails: [fetchedItemDetails.data],
  //           GetVideoUrlData: [fetchVideoUrl?.data],
  //         }));

  //         // sendMatomo(fetchedItemDetails.data);
  //         console.log("GetVideoUrlData...", GetVideoUrlData);
  //       } else if (
  //         fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==
  //         undefined &&
  //         fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 0
  //       ) {
  //         //STATE FOR NON_DRM_CONTENT
  //         console.log(
  //           "STATE FOR NON_DRM_CONTENT SET...............",
  //           GetVideoUrlData
  //         );
  //         setState((prevState) => ({
  //           ...prevState,
  //           loading: false,
  //           itemDetails: [fetchedItemDetails.data],
  //           GetVideoUrlData: [fetchVideoUrl?.data],
  //         }));
  //       }
  //     } else {
  //       setNoDataFound(true)
  //       setState((prevState) => ({
  //         ...prevState,
  //         isError: true,
  //         loading: false,
  //         shouldShowToast: false,
  //         toastMsg: "Playback error! Please try again later.",
  //         toastBgColor: "red",
  //       }));
  //     }

  //     if (firstTag === "Radio") {
  //       // LiveRadio-Selected-contentid/contentName event
  //       // await sendTestMatomoEvent({
  //       //   eventCategory: "LiveRadio",
  //       //   eventAction: "Selected",
  //       //   eventName: `${data?.id}/${data?.title}`,
  //       //   url: "details",
  //       // });
  //     } else if (firstTag === "TV") {
  //       // liveChannel event
  //       // await sendTestMatomoEvent({
  //       //   eventCategory: "LiveChannel",
  //       //   eventAction: "Selected",
  //       //   eventName: `${data?.id}/${data?.title}`,
  //       //   url: "details",
  //       // });
  //     }
  //     // }
  //     isGridCalled = false;
  //     // setPlansPrice(fetchedItemDetails?.data?.pricing?.s_price + fetchedItemDetails?.data?.pricing?.gst_amount);
  //   } catch (error) {
  //     // //console.error("Error fetching data:", error);
  //     setState((prevState) => ({
  //       ...prevState,
  //       loading: false,
  //       shouldShowToast: false,
  //       toastMsg: "Playback error! Please try again later.",
  //       toastBgColor: "red",
  //     }));
  //     isGridCalled = false;
  //   }
  // };

  const LiveLoadData = async () => {
    console.log("Selected item:");

    let headers = {
      platform: "0",
      "Content-Type": "application/json",
      // Authorization :`Bearer ${localStorage.getItem("JWTToken")}`,
    };
    try {
      let fetchedItemDetails = null;
      const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";

      fetchedItemDetails = await getLiveChannelDetails(data.id);
      console.log("fetchedItemDetails..", fetchedItemDetails.data, GetVideoUrlData);

      // if (data.owned_by == 0){
      if (fetchedItemDetails.data !== undefined) {

        setState((prevState) => ({
          ...prevState,
          loading: false,
          itemDetails: [fetchedItemDetails.data],
          GetVideoUrlData: [fetchedItemDetails?.data],
        }));

        console.log("GetVideoUrlData...", GetVideoUrlData, itemDetails);
      } else {
        setState((prevState) => ({
          ...prevState,
          isError: true,
          loading: false,
          shouldShowToast: false,
          toastMsg: "Playback error! Please try again later.",
          toastBgColor: "red",
        }));
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }

    // navigateToScreen('DetailsScreen', item);
  };

  useEffect(() => {
    console.log("livescreen...", isLiveScreen, data, isLiveEvent);
    // if(data?.still_live === 0 || isLiveScreen){
    //   console.log("livescreen...", isLiveScreen, data);
    loadData();
    // }else 
    // if (data?.still_live === 1 && !isLiveScreen && !isLiveEvent) {
    //   console.log("livescreen...", isLiveScreen, data);
    //   LiveLoadData();
    // } else {
    //   loadData();
    // }
    return () => { };
  }, []);

  useEffect(() => {
    if (GetVideoUrlData && GetVideoUrlData[0]) {
      setState((prevState) => ({
        ...prevState,
        GetVideoUrlData_audio: GetVideoUrlData,
      }));
    }

    console.log("itemDetails222", itemDetails)

    if (itemDetails && itemDetails.length > 0) {
      const sPrice = Number(itemDetails[0]?.pricing?.s_price || 0);
      const gstAmount = Number(itemDetails[0]?.pricing?.gst_amount || 0);
      setPlansPrice(sPrice + gstAmount);
    }
  }, [GetVideoUrlData, plansPrice, itemDetails]);

  const sendMatomo = async (itemDetails) => {
    let mediaType;

    console.log("first12", itemDetails, data);

    if (itemDetails?.type === 1) {
      mediaType = "AOD";
    } else if (itemDetails?.type === 0) {
      if (itemDetails?.is_paid === 0) {
        mediaType = "VOD";
      } else if (itemDetails?.is_paid === 1) {
        mediaType = "SVOD";
      } else if (itemDetails?.is_paid === 2) {
        mediaType = "TVOD";
      }
    } else {
      mediaType = "Unknown";
    }

    // console.log(itemDetails[0].publisher_id,"Motamooo", data);

    //

    // View
    // let eventCategory = "ContentDetailPage";
    // let eventAction = "View";
    // let eventName = `${data?.id}/${data?.title}(${mediaType})`;

    // await sendTestMatomoEvent({
    //   url: "details",
    //   eventCategory,
    //   eventAction,
    //   eventName,
    // });

    const publisherDetails = `${itemDetails?.publisher_id}/${itemDetails?.publisher_name}`;

    // Interaction
    await sendTestMatomoEvent(
      {
        action_name: `${data?.id}/${data?.title} - ${data?.genres
          ? data?.genres || "No generes"
          : data?.genre_titles || "No generes"
          }`,
      },
      {
        eventType: "content_interaction",
        c_i: "Content Detail Page/View",
        pubHouse: publisherDetails,
      }
    );

    // Impression
    await sendTestMatomoEvent(
      {
        action_name: `${data?.id}/${data?.title} - ${data?.genres
          ? data?.genres || "No genres"
          : data?.genre_titles || "No genres"
          }`,
      },
      { eventType: "content_impression" }
    );
  };

  const styles = {
    detailsContainer: {
      display: "flex",
      flexDirection: "column",
      background: "#000000",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the background image
      backgroundRepeat: "no-repeat", // Do not repeat the background image
    },
  };

  const adConfig = {};
  //   client: true,
  //   adTimes: [5, 10, 20], // Advertisement times in seconds
  //   vastXmlUrl: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=' // VAST XML advertisement URL
  // };

  const handleAdStart = () => {
    //  //console.log('Advertisement started');
  };

  const handleAdEnd = () => {
    //  //console.log('Advertisement ended');
  };

  const handlePlay = () => {
    // //console.log('Video playing');
  };

  const handlePause = () => {
    //  //console.log('Video paused');
  };

  const handleResume = () => {
    //  //console.log('Video resumed');
  };

  const handleForward = () => {
    //  //console.log('Video forwarded');
  };

  const handleRewind = () => {
    //  //console.log('Video rewinded');
  };

  const handleError = (error) => {
    //  //console.error('Video error:', error);
    navigateToScreen("DetailsScreen");
    setState((prevState) => ({
      ...prevState,
      shouldShowToast: true,
      toastMsg: "Playback error! Please try again later.",
      toastBgColor: "red",
      shouldFocusToScreenBG: true,
    }));
    setTimeout(function () {
      setState((prevState) => ({
        ...prevState,
        shouldShowToast: false,
        toastMsg: "",
        toastBgColor: "transparent",
      }));
    }, 2000);
  };

  const FocusHandler = () => { };

  const getItemDetails = () => {
    return itmDetails;
  };

  console.log(
    "itemDetails...",
    data,
    "DRMvdoSRC..",
    DRMvdoSRC,
    GetVideoUrlData,
    data
  );

  if (screen === "DetailsScreen") {
    ScreenComponent = (
      <ScreenBGItemScreen
        banneritems={NoDataFound ? [{}] : dataWrapper}
        callBack={callBack}
        animation={false}
        navigate={navigateToScreen}
        isDetails={true}
        isError={isError}
        FocusHandler={FocusHandler}
        shouldFocusToScreenBG={shouldFocusToScreenBG}
        isLogedIn={isLogedIn}
        itemDetails={itemDetails}
        handleErr={handleErr}
        onSelect={onSelect}
        isLiveEvent={isLiveEvent}
        getItemDetails={getItemDetails}
        isLiveScreen={isLiveScreen}
        shouldShowAuthModal={shouldShowAuthModal}
        shouldRemindPopup={shouldRemindPopup}
        shouldAuthError={shouldAuthError}
        VideoDataDrm={VideoDataDrm}
       
      />

    );
  } else if (screen === "VideoScreen") {
    ScreenComponent = (
      <VideoPlayer
        VideoDataDrm={VideoDataDrm}
        itemDetails={itemDetails}
        hasNextContent={hasNextContent}
        nextAvailableContent={episode}
        currentItemSeason={currentItemSeason}
        onSelect={onSelect}
        videoSrc={
          DRMvdoSRC !== null
            ? DRMvdoSRC
            : itemDetails !== undefined &&
              itemDetails[0] !== undefined &&
              itemDetails[0].file_url !== undefined &&
              itemDetails[0].file_url !== ""
              ? itemDetails[0].file_url
              : ""
        } //{"https://d1wxh31cdpnls0.cloudfront.net/file_library/videos/vod_non_drm_ios/3950783/1708263121_5562877026056109/1708263047709_773755746317671800_video_VOD.m3u8"}
        type={typ}
        // backgroundImage={
        //   data.detail_banner
        //     ? data.detail_banner
        //     : data.banner_url
        //     ? data.banner_url
        //     : data.poster_url ?? data.poster_url
        // }
        controlsColor="transparent"
        controlBarHeight="50px"
        progressBarColor="#EC008C"
        fullScreen={true}
        adConfig={adConfig}
        itemData={data}
        DrmInformatin={DrmInformatin}
        GetVideoUrlData={GetVideoUrlData}
        onAdStart={handleAdStart}
        onAdEnd={handleAdEnd}
        onPlay={handlePlay}
        onPause={handlePause}
        onResume={handleResume}
        onForward={handleForward}
        onRewind={handleRewind}
        onError={handleError}
        onBack={handleVideoBack}
        isLive={isLiveScreen}
        DRMToken={DRMToken}
        apiEndpoint="https://api.example.com/pause"
      />
    );
  } else if (screen === "PDFViewer") {
    ScreenComponent = (
      <PDFViewer
        itemDetails={itemDetails}
        documentUrl={
          itemDetails[0].extra_json.documentUrl?.endsWith(".html") ||
            itemDetails[0].extra_json.documentUrl?.endsWith(".htm")
            ? itemDetails[0].thumbnail
            : itemDetails[0].extra_json.documentUrl
        }
        onBack={handleVideoBack}
      />
    );
  } else if (screen === "AudioPlayer") {
    ScreenComponent = (
      <AudioPlayer
        videoSrc={
          DRMvdoSRC !== null
            ? DRMvdoSRC
            : itemDetails !== undefined &&
              itemDetails[0] !== undefined &&
              itemDetails[0].file_url !== undefined &&
              itemDetails[0].file_url !== ""
              ? itemDetails[0].file_url
              : ""
        } //{"https://d1wxh31cdpnls0.cloudfront.net/file_library/videos/vod_non_drm_ios/3950783/1708263121_5562877026056109/1708263047709_773755746317671800_video_VOD.m3u8"}
        type={typ}
        backgroundImage={
          data.detail_banner
            ? data.detail_banner
            : data.banner_url
              ? data.banner_url
              : data.poster_url ?? data.poster_url
        }
        controlsColor="transparent"
        controlBarHeight="50px"
        progressBarColor="#EC008C"
        fullScreen={true}
        adConfig={adConfig}
        itemData={data}
        DrmInformatin={DrmInformatin}
        trackData={itemDetails?.[0]?.season?.[0]?.videos}
        itemDetails={itemDetails}
        GetVideoUrlData={GetVideoUrlData_audio}
        // GetVideoUrlData={GetVideoUrlData}
        onAdStart={handleAdStart}
        onAdEnd={handleAdEnd}
        onPlay={handlePlay}
        onPause={handlePause}
        onResume={handleResume}
        onForward={handleForward}
        onRewind={handleRewind}
        onError={handleError}
        onBack={handleVideoBack}
        isLive={false}
        DRMToken={DRMToken}
        apiEndpoint="https://api.example.com/pause"
      />
    );
  }

  console.log("shouldRemindPopup...", shouldRemindPopup);

  return (
    <div style={styles.detailsContainer}>
      {loading && <LoaderScreen />}

      {ScreenComponent}
      {/* <ToastScreen
        disply={shouldShowToast ? "none" : "none"}
        msg={toastMsg}
        toastBgColor={toastBgColor}
      /> */}
      <ModalScreen
        shouldRental={shouldRental}
        premiumQr={premiumQr}
        shouldShowError={shouldShowError}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        okaybtn={okaybtn}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        data={data}
        shouldRemindPopup={shouldRemindPopup}
        remindPopup={remindPopup}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
      />
      {/* {state.isError && <ErrorScreen errorIcon={errorIcon} bgcolor="#0E1653"/>} */}
      <ErrorScreen errorIcon={errorIcon} disply={isError ? "flex" : "none"} bgcolor="#0E1653" homepage={true} />
      <AuthFailModal
        shouldShowError={shouldShowAuthModal || shouldRental}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
        premiumQr={premiumQr}
      />
    </div>
  );
};
export default DetailsScreen;